// import {fetch} from './zk-fetch'
import fetch from './fetch'

/**
 * 批量获取上传配置
 * @param {*} params
 * @param {Array} params.images
 * @param {String} params.images.type 【必须】资源类型：image、video
 * @param {String} params.images.ext 【必须】资源扩展名
 * @param {String} params.images.width 【必须】资源宽度
 * @param {String} params.images.height 【必须】资源高度
 * @param {String} params.images.size 【必须】资源大小
 * @param {String} params.images.length 【必须】视频时长
 */
export const getAliyunUploadConfig = (params) => {
  const customHeader = { 'Content-Type': 'application/json' }
  return fetch.exec('/new_get_batch_upload_config', params, { method: 'POST', header: customHeader })
}

/**
 * 社区媒体资源上传（用于电子相册和社区）
 * @param {Object} param 社区媒体资源上传
 * @param {String} param.type 【必须】资源类型：image、video
 * @param {String} param.ext 【必须】资源扩展名
 * @param {String} param.width 【必须】资源宽度
 * @param {String} param.height 【必须】资源高度
 * @param {String} param.size 【必须】资源大小
 * @param {String} param.length 【必须】视频时长
*/
export const getAliyunSingleUploadConfig = (params) => {
  return fetch.exec('/new_get_media_up_config', params, { method: 'POST' })
}